import { CURRENT_USER, type CurrentUser } from '@/graphql/user';
import { useQuery } from '@urql/vue';
import { computed } from 'vue';

export function useUser() {
  const { data: dataCurrentUser, fetching: isLoadingUser } = useQuery({
    query: CURRENT_USER,
    context: {
      requestPolicy: 'cache-and-network'
    }
  });

  const user = computed((): CurrentUser | null => (dataCurrentUser.value ? dataCurrentUser.value.user : null));
  const isLoggedIn = computed(() => (user.value ? !!user.value : false));
  const isGlobalSuperAdmin = computed(() => (user.value ? user.value.role.isGlobalSuperAdmin : false));
  const isGlobalAdmin = computed(() => (user.value ? user.value.role.isGlobalAdmin : false));
  const isGlobalOperator = computed(() => (user.value ? user.value.role.isGlobalOperator : false));
  const isGlobalReadonly = computed(() => (user.value ? user.value.role.isGlobalReadonly : false));
  const inMaintenance = computed(() => (user.value ? user.value.inMaintenance : false));

  return {
    isLoadingUser,
    isLoggedIn,
    user,
    isGlobalSuperAdmin,
    isGlobalAdmin,
    isGlobalOperator,
    isGlobalReadonly,
    inMaintenance
  };
}
